import styled from "styled-components";
import SVG from "react-inlinesvg";
import { Link } from "react-router-dom";
import map from "../../Images/addressPage/map.jpg";
export const Container = styled.div`
  /* margin-top: 138px; */
  height: calc(100vh - 76px);
  @supports (height: calc(100svh - 76px)) {
    height: calc(100svh - 76px);
  }

  background: var(--background);
  width: 100%;
  display: flex;
  align-content: flex-start;
  gap: 23px;
  flex-direction: column;
  z-index: 1;
  background-image: url(${map});
`;
export const BoxItems = styled.div`
  /* margin-top: 138px; */
  height: calc(61vh - 113px);
  @supports (height: calc(61svh - 113px)) {
    height: calc(61svh - 113px);
  }
  background: var(--background);
  width: 100%;
  display: flex;
  align-content: flex-start;
  gap: 23px;
  flex-wrap: wrap;
  overflow-x: hidden;
  padding-top: 6px;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const DivPrices = styled.div`
  height: 18vh;
  @supports (height: 18svh) {
    height: 18svh;
  }

  background: var(--backgroundPrices);
  width: 85vw;
  margin-inline: auto;
  display: flex;
  align-content: flex-start;
  gap: 12px;
  flex-direction: column;
  border-radius: 22px;
  justify-content: center;
  padding-inline: 20px;
  tr {
    border-bottom: 1px dashed;
  }
`;
export const Price = styled.div`
  width: 100%;
  margin-inline: auto;
  display: flex;
  align-content: flex-start;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  span {
    margin-inline-start: 10px;
  }
  p {
    font-weight: 900;
    ${({ final }) => final && "color:var(--secondColor);"}
  }
`;
export const Helper = styled.p`
  width: 85vw;
  margin-inline: auto;
  color: var(--secondColor);
  text-align: right;
  font-size: 14.2px;
  font-style: normal;
  font-weight: 700;
  padding-top: 13px;
`;

export const TextNoItems = styled.div`
  /* margin-top: 138px; */
  height: calc(90vh - 205px);
  @supports (height: calc(90svh - 205px)) {
    height: calc(90svh - 205px);
  }

  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    font-size: 11px;
    font-weight: 600;
  }
`;

export const DivSearch = styled.div`
  width: 85vw;
  height: 51px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  white-space: nowrap;
`;
export const DivInput = styled.div`
  position: relative;
  height: 51px;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;
export const Input = styled.input`
  padding-inline-start: 50px;
  padding-inline-end: 14px;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  height: 100%;
  width: 100%;
  background-color: white;
  border-radius: 17px;
  border: 1px solid var(--searchStrokeColor);
  margin: 0;
  outline: none;
  &::placeholder {
    color: var(--placeholder);
    opacity: 1; /* Firefox */
  }
  &::-ms-input-placeholder {
    /* Edge 12-18 */
    color: var(--placeholder);
  }
`;
export const IconInput = styled.img`
  position: absolute;
  height: 51px;
  width: 51px;
  & path {
    stroke: var(--firstColor);
  }
  & circle {
    stroke: var(--firstColor);
    fill: var(--firstColor);
  }
`;
export const ButtonFilter = styled.button`
  height: 51px;
  min-width: 51px;
  outline: none;
  border: none;
  background: var(--firstColor);
  border-radius: 17px;
`;
export const ImgFilter = styled.img`
  height: 51px;
  max-width: 51px;
`;
export const DivRaedyCarts = styled.div`
  width: 88vw;
  border: 1px solid var(--firstColor);
  border-radius: 17px 17px 0 0;
  background: white;
`;
export const RaedyCart = styled.div`
  position: relative;
  margin-inline: 30px;
  width: calc(100% - 60px);
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #6d4c10;
  border-bottom: 1px solid var(--separatorReadyCarts);

  &:last-child {
    border-bottom: none;
  }
  p {
    width: 100%;
    text-align: center;
    padding-inline: 42px;
  }
`;
export const ButtonAddRaedyCart = styled.div`
  width: 88vw;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: white;
  background: var(--firstColor);
  border-radius: ${({ emptyReadyCart }) =>
    emptyReadyCart ? "17px" : "0 0 17px 17px"};
  p {
    text-align: center;
    margin-left: 35px;
  }
`;
export const ImgReadyCart = styled(SVG)`
  position: absolute;
  right: 0;
  & path {
    &:nth-child(1) {
      stroke: var(--firstColor);
    }
    &:nth-child(3) {
      fill: var(--firstColor);
    }
    &:nth-child(4) {
      fill: var(--firstColor);
    }
  }
`;
export const DivItems = styled.div`
  width: 85vw;
  margin: auto;
  display: flex;
  align-content: flex-start;
  row-gap: 14px;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const Item = styled.div`
  font-size: 13px;
  width: 100%;
  min-height: 90px;
  position: relative;
  color: ${({ active }) => (active ? "white" : "black")};
  border-radius: 22px;
  position: relative;
`;
export const Card = styled(SVG)`
  position: relative;
  top: 0;
  right: 0;
  height: 100%;
  width: 100%;
  margin-top: -0.3vw;
  & path {
    transition: all 0.2s ease-in-out;
    fill: ${({ active }) => (active ? "var(--firstColor)" : "white")};
  }
`;
export const DivImg = styled.div`
  width: 30px;
  height: 30px;
`;
export const Img = styled.img`
  min-height: 100%;
  max-height: 100%;
  width: 100%;
  border-radius: 50%;
`;
export const DivDiscount = styled.div`
  border-radius: 11px;
  padding: 4px 6px;
  position: absolute;
  bottom: -6%;
  right: 5%;
  background: var(--secondColor);
  color: white;
  font-size: 10px;
  font-weight: 900;
  border: solid 4px var(--background);
`;
export const BtnReadyCart = styled.div`
  position: absolute;
  ${({ type }) =>
    (type === "delete" && "right:0;top: 3.5%;") ||
    (type === "addToShoppingCart" && "left:0;bottom: 4.5%;")};
  height: 30.2%;
  width: 10%;
  display: flex;
  background: ${({ type }) =>
    type === "delete" ? "var(--red)" : "var(--firstColor)"};
  border-radius: 42%;
`;
export const Btn = styled.div`
  margin-top: -3px;
  height: 9vw;
  width: 9vw;
  display: flex;
  background: var(--red);
  border-radius: 42%;
  -webkit-tap-highlight-color: transparent; // حذف هایلایت آبی در دستگاه‌های لمسی
  transition: all 0.2s ease-in-out;
  &:active {
    filter: brightness(0.75);
  }
`;
export const DivQuantity = styled.div`
  position: absolute;
  left: 10.4%;
  bottom: 0;
  height: 20.9%;
  width: 9%;
  display: flex;
  flex-direction: column;
  margin-bottom: 1%;
  justify-content: center;
`;
export const Quantity = styled.p`
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
`;
export const MeasureUnit = styled.p`
  font-size: 7px;
  font-style: normal;
  font-weight: 700;
  text-align: center;
  color: var(--measureUnitColor);
`;
export const DivStar = styled.div`
  position: absolute;
  left: 0.4%;
  top: 2.6%;
  height: 16%;
  width: 15%;
  background: var(--startBackgroundProductPage);
  display: flex;
  border-radius: 12px 0px 12px 0px;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  gap: 3px;
  img {
    margin-top: -2px;
  }
`;
export const DivDetails = styled.div`
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  div {
    display: flex;
    flex-direction: row;
    gap: 4vw;
  }
`;

export const DivTitle = styled.div`
  margin-top: -3px;
  display: flex;
  align-items: center;
  gap: 9px;
  background: var(--secondColor);
  margin-left: auto;
  padding-left: 24px;
  border-radius: 5px 5px 15px 15px;
`;

export const Title = styled.p`
  font-size: 13px;
  font-weight: 800;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: white;
`;
export const Address = styled.p`
  padding-inline: 23px;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  width: 100%;
  height: 100%;
  padding-block: 1.8%;
  display: flex;
  align-items: center;
  text-align: justify;
`;

export const Icon = styled.img`
  height: 100%;
  width: 100%;
`;
export const ContainerTextBoxComment = styled.div`
  position: fixed;
  width: 100vw;
  bottom: 0;
  padding: 20px 6vw;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(31.5px);
  -webkit-backdrop-filter: blur(31.5px);
  z-index: 0;
  display: flex;
  gap: 5%;
`;
export const DivInputAndBtn = styled.div`
  width: 84%;
`;
export const DivRate = styled.div`
  width: 11%;
  direction: ltr;
  flex-direction: column;
  align-items: center;
  display: flex;
  justify-content: center;
  background: white;
  border-radius: 17px;
  border: 1px solid var(--searchStrokeColor);
`;
export const ContainerShowShoppingCart = styled.div`
  position: fixed;
  height: 10vh;
  @supports (height: 10svh) {
    height: 10svh;
  }

  width: 100vw;
  bottom: 0;
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(31.5px);
  -webkit-backdrop-filter: blur(31.5px);
  z-index: 0;
  transform: ${({ show }) =>
    show ? "translate(0%, 0%) scale(1)" : "translate(0%, 100%) scale(1)"};
  transition: transform 0.3s ease-in-out;
`;
export const DivShowShoppingCart = styled.div`
  height: 10vh;
  @supports (height: 10svh) {
    height: 10svh;
  }

  width: 87vw;
  margin-inline: auto;
  display: flex;
  align-items: center;
`;
export const ButtonNext = styled.div`
  height: 6vh;
  @supports (height: 6svh) {
    height: 6svh;
  }

  min-width: 62%;
  background: var(--secondColor);
  border-radius: 13px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 900;
  text-decoration: none;
  -webkit-tap-highlight-color: transparent; // حذف هایلایت آبی در دستگاه‌های لمسی
  transition: all 0.2s ease-in-out;
  &:active {
    filter: brightness(0.75);
  }
`;
export const ButtonInsertComment = styled.div`
  height: 6vh;
  @supports (height: 6svh) {
    height: 6svh;
  }

  min-width: 62%;
  background: var(--firstColor);
  border-radius: 13px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-style: normal;
  font-weight: 900;
  text-decoration: none;
`;
export const SumPrice = styled.p`
  font-size: 15px;
  font-style: normal;
  font-weight: 900;
  width: 100%;
  text-align: center;
`;
export const UnitSumPrice = styled.span`
  color: var(--secondColor);
  margin-inline-start: 5px;
`;
export const DivBtnBottomSheet = styled.div`
  height: 50px;
  width: 88vw;
  margin-inline: auto;
  display: flex;
  align-items: center;
  gap: 25px;
`;
export const BtnBottomSheet = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ type }) => (type === "ok" ? "var(--green)" : "var(--red)")};
  color: white;
  border-radius: 13px;
`;
